import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function authHeaders() {
  const t = sessionStorage.getItem("plena_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);

export const adminMe = () =>
  axios.get(`${API}/admin/me`, { headers: authHeaders() }).then((r) => r.data);

export const listTenants = () =>
  axios.get(`${API}/tenants`, { headers: authHeaders() }).then((r) => r.data);

export const createTenant = (payload) =>
  axios.post(`${API}/tenants`, payload, { headers: authHeaders() }).then((r) => r.data);

export const updateTenant = (slug, payload) =>
  axios.patch(`${API}/tenants/${slug}`, payload, { headers: authHeaders() }).then((r) => r.data);

export const deleteTenant = (slug) =>
  axios.delete(`${API}/tenants/${slug}`, { headers: authHeaders() }).then((r) => r.data);

export const publicTenantMeta = (slug) =>
  axios.get(`${API}/tenants/public/${slug}`).then((r) => r.data);

export const verifyTenant = (slug, password) =>
  axios.post(`${API}/tenants/${slug}/verify`, { password }).then((r) => r.data);
